import {combineReducers} from 'redux';
import authReducer from './authentication/authenticationReducer';
import communicationsReducer from "./communications/communicationsReducer";
import newCommunicationReducer from "./communications/newCommunicationReducer";
import vendorConcentrationMapReducer from "./vendors/vendorConcentrationMapReducer";
import pollPortalReducer from "./pollPortal/pollPortalReducer";
import mapOverlayReducer from "./mapOverlays/mapOverlayReducer";

const rootReducer = combineReducers({
    authentication: authReducer,
    communications: communicationsReducer,
    newCommunication: newCommunicationReducer,
    pollPortal: pollPortalReducer,
    vendors : vendorConcentrationMapReducer,
    mapOverlays: mapOverlayReducer
});

export default rootReducer;
